import { useId } from 'react';

/**
 * UndoAnimatedIcon — Ícone de cancelar/desfazer animado padrão do Joshua.
 *
 * Uso: envolva com um elemento que tenha a classe `undo-animated`
 * para ativar a animação no hover (seta chicoteia, arco gira).
 *
 * Exemplo:
 *   <button className="btn-add undo-animated" onClick={onCancel}>
 *     <UndoAnimatedIcon size={15} />
 *     <span className="btn-text">Cancelar</span>
 *   </button>
 */
export default function UndoAnimatedIcon({ size = 15 }) {
  const id = useId();
  const gid = `undoG${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="3" y1="12" x2="21" y2="12">
          <stop offset="0%" stopColor="#9ca3af" />
          <stop offset="100%" stopColor="#4b5563" />
        </linearGradient>
      </defs>
      <g className="undo-arrow" stroke={`url(#${gid})`}>
        <path d="M3 7v6h6"/>
      </g>
      <g className="undo-path" stroke={`url(#${gid})`}>
        <path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"/>
      </g>
    </svg>
  );
}
